import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EarningRoutingModule} from './earning-routing.module';
import {PairingBonusComponent} from './pairing-bonus/pairing-bonus.component';
import {SelfRePurchaseBonusComponent} from './self-re-purchase-bonus/self-re-purchase-bonus.component';
import {PerformanceBonusComponent} from './performance-bonus/performance-bonus.component';
import {LeadershipBonusComponent} from './leadership-bonus/leadership-bonus.component';
import {DirectorBonusComponent} from './director-bonus/director-bonus.component';
import {CarFundBonusComponent} from './car-fund-bonus/car-fund-bonus.component';
import {HouseFundBonusComponent} from './house-fund-bonus/house-fund-bonus.component';
import {TourFundBonusComponent} from './tour-fund-bonus/tour-fund-bonus.component';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [PairingBonusComponent, SelfRePurchaseBonusComponent, PerformanceBonusComponent, LeadershipBonusComponent, DirectorBonusComponent, CarFundBonusComponent, HouseFundBonusComponent, TourFundBonusComponent],
    imports: [
        CommonModule,
        EarningRoutingModule,
        NgbPaginationModule,
        ReactiveFormsModule
    ]
})
export class EarningModule {
}
